import React from 'react';
import '../styles/NotFound.css';

export default function NotFound() {
  return (
    <div class="container">
      <h1 class="neonText">
            404
      </h1>
      <h2 class="neonText">Page Not Found</h2> 
    </div>
  )
}
